import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import { useGoogleAuthMutation } from 'src/redux/Api/authApi'
import { setCredentials } from 'src/redux/Slices/authSlice'

const GoogleAuth = () => {
  const [googleAuth] = useGoogleAuthMutation()
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const prev = location.state?.from?.pathname || '/'

  const handleError = () => {
    console.log('Error')
  }

  const handleSuccess = async (response: any) => {
    const data = await googleAuth(response.credential).unwrap()
    dispatch(setCredentials(data.data))
    navigate(prev, { replace: true })
  }

  return (
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        text="continue_with"
        shape="rectangular"
        containerProps={{
          style: {
            width: '100%'
          },
          className: 'google_btn'
        }}
      />
    </GoogleOAuthProvider>
  )
}

export default GoogleAuth
